import styles from './ShopHeader.module.css';


const ShopHeader = ({account, setSelectedOption, selectedOption, marginTop, shopItems, setAuthModalPage, setIsHotModalShown, setUserModalPage, setModalProps}) => {
	const categoryIcons = {
		'핫플': 'images/fire.svg',
		'커피/음료': 'images/cafe.svg',
		'편의점': 'images/popupStore.svg',
		'마트': 'images/coin.svg',
		'영화': 'images/car_theater.svg',
		'버거': 'images/burger.svg',
		'아이스크림': 'images/icecream.svg',
		'피자': 'images/pizza.svg',
		'치킨': 'images/chicken.svg',
		'베이커리/도넛': 'images/bakery.svg',
	};

	const categoryFilters = {
		'핫플': 'brightness(0) saturate(100%) invert(17%) sepia(80%) saturate(6164%) hue-rotate(331deg) brightness(110%) contrast(114%)',
		'마트': 'brightness(0) saturate(100%) invert(69%) sepia(85%) saturate(585%) hue-rotate(0deg) brightness(106%) contrast(104%)',
		'영화': 'brightness(0) saturate(100%) invert(28%) sepia(0%) saturate(4%) hue-rotate(140deg) brightness(98%) contrast(85%)',
		'버거': 'brightness(0) saturate(100%) invert(66%) sepia(49%) saturate(4209%) hue-rotate(0deg) brightness(103%) contrast(105%)',
		'아이스크림': 'brightness(0) saturate(100%) invert(60%) sepia(100%) saturate(2327%) hue-rotate(155deg) brightness(104%) contrast(105%)',
		'피자': 'brightness(0) saturate(100%) invert(76%) sepia(90%) saturate(493%) hue-rotate(324deg) brightness(102%) contrast(92%)',
		'치킨': 'brightness(0) saturate(100%) invert(31%) sepia(92%) saturate(5330%) hue-rotate(35deg) brightness(90%) contrast(101%)',
		'베이커리/도넛': 'brightness(0) saturate(100%) invert(23%) sepia(92%) saturate(2015%) hue-rotate(19deg) brightness(100%) contrast(105%)',
	};

	function whenCategoryClicked(category){
		setSelectedOption((prev)=>({...prev, shop_category: category, shop_brand: 'popular'}));
	}

	const handleLimitBadgeClicked = (event) => {
		event.stopPropagation();
		setUserModalPage(4);
	};

	function whenHeaderClicked(){
		if(account.hotpleId==null)
			setAuthModalPage(1);
		else{
            setModalProps({type:'HP'});
			setUserModalPage(6);
		}
	}

	function whenPlusClicked(event){
		event.stopPropagation();
		alert(`HP는 '핫플 스토리 기능'과 '각종 이벤트 참여'를 통해 모을 수 있어요!\n\n*핫플 스토리 기능은 베타 테스트 종료 후 제공될 예정입니다😉`);
		setIsHotModalShown(true);
	}

  	return (
    		<div style={{marginTop: `${marginTop}px`}} className={styles.mapHeader}>
      			<div className={styles.locationSearchBar} onClick={whenHeaderClicked}>
					{account.hotpleId==null ?
						<div className={styles.div}>
							<img className={styles.iconchevronBottom} alt="" src="images/info.svg" />
							<div className={styles.div4}>로그인이 필요합니다 </div>			
						</div>
					:
						<div className={styles.div}>
							<img className={styles.iconchevronBottom} alt="" src="images/fire.svg" />
							<div className={styles.div1}>HP 보유량 </div>			
							<img className={styles.iconchevronBottom} alt="" src="images/chevron_bottom.svg" />		
							<div className={styles.km}>{account.hp} HP</div>
							{account.level>0 && <div className={'buttonBadge'} style={{top:'6px',right:'12px'}} onClick={handleLimitBadgeClicked}>Lv.{account.level} 할인 적용 중</div>}
						</div>
					}
					{account.hotpleId==null ?
						<div className={styles.right}>
							<div className={styles.div2}>
									<img className={styles.iconchevronBottom} alt="" src="images/chevron_bottom.svg" />
							</div>
						</div>
					:
						<div className={styles.right} onClick={whenPlusClicked}>
							<div className={styles.div2}>
									<img className={styles.iconsearch} alt="" src="images/plus_line.svg" />
							</div>
						</div>
					}
      			</div>
      			<div className={styles.categorybuttons}>
					<div className={styles.div3}>
						<div className={styles.list}>
							<div className={`${selectedOption.shop_category === 'top20' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} key='top20' onClick={() => whenCategoryClicked('top20')}>
								<img className={styles.iconstarFilled} alt="" src="images/star_filled.svg" />
								<div className={styles.label}>TOP20</div>
							</div>

							{[...new Set(shopItems.sort((a, b) => b.sale_count - a.sale_count).map(item => item.goods_type_dtl_nm))]
							.map((category, index) => (
								<div className={`${selectedOption.shop_category === category ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked(category)}>
									<img className={styles.iconstarFilled} alt="" src={categoryIcons[category] || 'images/default.svg'} style={{ filter: categoryFilters[category] || 'none' }} />
									<div className={styles.label}>{category}</div>
								</div>
							))}
						</div>
					</div>
      			</div>
    		</div>);
};

export default ShopHeader;
